import { render, staticRenderFns } from "./activityGroupBuy.vue?vue&type=template&id=b2ca534a&"
import script from "./activityGroupBuy.vue?vue&type=script&lang=js&"
export * from "./activityGroupBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports